import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import { AppSettings } from './proyect.conf';
import { inicializarLogger } from './app/utils/console-logger';

// Inicializar la intercepción de logs de consola
inicializarLogger();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

